<div class="auth">
  <div
    class="auth__card"
    [ngClass]="{ 'auth__card--register': isRegisterRoute }"
  >
    <!-- Brand panel -->
    <div class="auth__brand">
      <img
        class="auth__brand-logo"
        src="../../../../../assets/images/logo-login.png"
        alt="LOMY"
      />
      <div class="auth__wordmark">
        <app-lomy-logo size="h1"></app-lomy-logo>
      </div>
      <div class="auth__tagline">
        {{ (isRegisterRoute ? "auth.registerTitle" : "auth.title") | transloco }}
      </div>
      <p class="auth__desc">
        {{
          (isRegisterRoute ? "auth.registerSubtitle" : "auth.subtitle")
            | transloco
        }}
      </p>
    </div>

    <div class="auth__divider"></div>

    <!-- Form panel -->
    <div class="auth__panel">
      <router-outlet></router-outlet>
    </div>
  </div>

  <!-- Language switcher -->
  <div class="auth__langs">
    <a
      *ngFor="let lang of availableLanguages"
      [class.is-active]="currentLang === lang.lang"
      (click)="switchLanguage(lang.lang)"
    >
      {{ lang.name }}
    </a>
  </div>
</div>
<app-spinner [enableSpinner]="_auth.loading"></app-spinner>
